import * as React from 'react';

type Props = {
  renderFallback?: () => React.ReactNode;
};

export default class ErrorBoundary extends React.Component<
  Props,
  { hasError: boolean }
> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: any): { hasError: boolean } {
    console.error(error);
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  // TODO: add logging here?
  // componentDidCatch(error, errorInfo): void {
  //   // You can also log the error to an error reporting service
  //   logErrorToMyService(error, errorInfo);
  // }

  render(): React.ReactNode {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <>{this.props.renderFallback ? this.props.renderFallback() : null}</>
      );
    }

    return this.props.children;
  }
}
